import { render, staticRenderFns } from "./kindChooseViews.vue?vue&type=template&id=4dcbd764&scoped=true"
import script from "./kindChooseViews.vue?vue&type=script&lang=js"
export * from "./kindChooseViews.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViews.vue?vue&type=style&index=0&id=4dcbd764&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcbd764",
  null
  
)

export default component.exports